import { connect } from 'react-redux';
import LeaveAReview from './index';
import { reviewSubmitted, starRatingUpdated } from '../../ducks/leaveAReview';

const mapStateToProps = (state: any) => ({
  location: state.location,
  leaveAReview: state.leaveAReview,
});

const mapDispatchToProps = (dispatch: any) => ({
  onChange: (update: any) => dispatch(starRatingUpdated(update)),
  submit: (formData: any) => dispatch(reviewSubmitted(formData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveAReview);
